import { render, staticRenderFns } from "./PsPageContainer.vue?vue&type=template&id=4125627c&scoped=true&"
import script from "./PsPageContainer.vue?vue&type=script&lang=js&"
export * from "./PsPageContainer.vue?vue&type=script&lang=js&"
import style0 from "./PsPageContainer.vue?vue&type=style&index=0&id=4125627c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4125627c",
  null
  
)

export default component.exports